const getDefaultColor = () => {
  return '#2a3042'
}
export default getDefaultColor
